import { useState, useEffect } from 'react';

export default function useTaskData() {
    const [taskId, setTaskId] = useState(1);
    // const [taskDataInitialized, setTaskDataInitialized] = useState(false);

    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        const taskIdParam = queryParams.get("taskid");
        // parse to int and set to 0 as fallback
        const idToUse = parseInt(taskIdParam, 10) || 0;

        localStorage.setItem('currentTaskId', idToUse.toString());
        setTaskId(idToUse);
    }, []);

    const resetAllTaskData = () => {
        setTaskId(0);
        localStorage.removeItem('currentTaskId');
        localStorage.removeItem('currentIteration');
    };

    const resetImages = () => {
        setCurrentImages([]);
        setCurrentImageIndex(0);
    };

    const resetRatings = () => {
        setRatedImages({});
    };

    return {
        taskId,
        setTaskId,
        resetAllTaskData
    };
}
